<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size"
    viewBox="0 0 24 24"><!-- Icon from BoxIcons by Atisa - https://creativecommons.org/licenses/by/4.0/ -->
    <path fill="currentColor"
      d="m16.192 6.344l-4.243 4.242l-4.242-4.242l-1.414 1.414L10.535 12l-4.242 4.242l1.414 1.414l4.242-4.242l4.243 4.242l1.414-1.414L13.364 12l4.242-4.242z" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'BxX',
  props: {
    size: {
      type: [Number, String],
      default: "1em",
    },
  },
}
</script>